import type { ErrorCodes } from '../literals';

export class CustomError<T = unknown> extends Error {
  constructor(public message: string, public status: ErrorCodes, public data?: T) {
    super(message);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }

    this.name = 'CustomError';
  }
}
